// extracted by mini-css-extract-plugin
export default {"root":"UserRoleText-root-0204fdb6d942e636a9e0e26a97dc68fe","commenter":"UserRoleText-commenter-79102eea7ac6772df4d8c7611017fae2"};